module.exports = __webpack_public_path__ + "img/selected2-min.2c86ff9b.png";